import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Icon, Flex } from 'components/ui';
import Empty from 'constants/empty';
import localeUtils from 'utils/LanguageLocale';
import EN from 'components/ShopYourStore/StoreShoppingOptions/locales/StoreShoppingOptions_en_US.js';
import FR from 'components/ShopYourStore/StoreShoppingOptions/locales/StoreShoppingOptions_fr_CA.js';

const getText = localeUtils.getLocalisedDataFromResource(EN, FR);

function StoreShoppingOptions(props) {
    const { options } = props;

    return (
        <Flex
            rowGap={1}
            columnGap={2}
            flexWrap='wrap'
            marginTop={3}
            lineHeight='tight'
        >
            {options.map(option => {
                if (!option.available) {
                    return null;
                }

                return (
                    <Flex
                        key={'shopping_option_' + option.translationKey}
                        gap='2px'
                        alignItems='center'
                    >
                        <Icon
                            name='checkmark'
                            color='green'
                            size='14px'
                        />
                        <Text
                            fontSize='sm'
                            color='gray'
                        >
                            {getText(option.translationKey)}
                        </Text>
                    </Flex>
                );
            })}
        </Flex>
    );
}

StoreShoppingOptions.propTypes = {
    options: PropTypes.array
};

StoreShoppingOptions.defaultProps = {
    options: Empty.Array
};

export default wrapFunctionalComponent(StoreShoppingOptions, 'StoreShoppingOptions');
